<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_georgian_bars' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <!-- Configuration mode -->
    <div class="mode-card">
      <div class="mode-label">
        {{ 'configuration_mode' | translate }}
      </div>

      <ion-segment [value]="configType" (ionChange)="onModeChange($event)" mode="md">
        <ion-segment-button value="shapes">
          <ion-label>{{ 'HEADER_MUNTIN_SHAPES' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="advanced">
          <ion-label>{{ 'HEADER_ADVANCED' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <ng-container *ngIf="this.configType=='shapes'" class="contentDiv">
      <ion-list>
        <ng-container *ngFor="let obj of barShapesData">
          <ion-item lines="none" class="cardDiv" (click)="selectBarOpt(obj.id)"
            [ngClass]="obj['id'] == selectedBar ? 'selected' : ''" *ngIf="(obj['name'] | translate)?.trim()">
            <div class="image-container">
              <img [src]="obj.img" class="square-image" />
            </div>
            <div class="content-container">
              <h5 class="card-title">{{obj.name | translate}}</h5>
            </div>
          </ion-item>
        </ng-container>
      </ion-list>
    </ng-container>

    <ng-container *ngIf="this.configType=='advanced'" class="contentDiv">
      <div class="select-group">
        <ion-label class="select-label">{{'WINDOW_TYPE_HORIZONTAL' | translate}}</ion-label>

        <ion-select [(ngModel)]="selectedHorizontal" interface="popover" class="styled-select">
          <ion-select-option *ngFor="let obj of barHeightData" [value]="obj">
            {{obj}}
          </ion-select-option>
        </ion-select>
      </div>

      <div class="select-group">
        <ion-label class="select-label">{{'WINDOW_TYPE_VERTICAL' | translate}}</ion-label>

        <ion-select [(ngModel)]="selectedVertical" interface="popover" class="styled-select">
          <ion-select-option *ngFor="let obj of barHeightData" [value]="obj">
            {{obj}}
          </ion-select-option>
        </ion-select>
      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'next' | translate}}
    </ion-button>
  </div>
</ion-footer>